import { gql } from '@apollo/client';

export const DEPOSIT_TRANSFERS_REPORT = gql`
  query depositTransferReport(
    $input: DepositTransferReportInput!
    $page: Int
    $first: Int
  ) {
    depositTransferReport(input: $input, page: $page, first: $first) {
      data {
        transfer {
          club {
            name
            id
          }
          sum
          type
          created_at
        }
        user {
          avatar_url
          phone
          middle_name
          last_name
          first_name
        }
      }
      paginatorInfo {
        currentPage
        lastPage
      }
    }
  }
`;

export const DEPOSIT_TRANSFERS_REPORT_CSV = gql`
  query depositTransferReport($input: DepositTransferReportInput!) {
    depositTransferReport(input: $input) {
      url
    }
  }
`;

export const DEPOSIT_TRANSFERS_SUMMARY_REPORT = gql`
  query depositTransferSummaryReport($input: ReportInput!) {
    depositTransferSummaryReport(input: $input) {
      data {
        values
      }
      extraLabels
      summary {
        title
        value
      }
    }
  }
`;
